import { Component, Input } from '@angular/core';
import { WeekDay } from 'calendar-utils';


export class CalendarWeekViewHeaderComponent {

   day: WeekDay;

   locale: string;

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mwl-calendar-week-view-header',
  template: `
    <b>{{ day.date | calendarDate:'weekViewColumnHeader':locale }}</b><br>
    <span>{{ day.date | calendarDate:'weekViewColumnSubHeader':locale }}</span>
  `,
  host: {
    '[class]': '"cal-header"',
    '[class.cal-past]': 'day.isPast',
    '[class.cal-today]': 'day.isToday',
    '[class.cal-future]': 'day.isFuture',
    '[class.cal-weekend]': 'day.isWeekend'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'day': [{ type: Input },],
'locale': [{ type: Input },],
};
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
